import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';

import IntakeForm from '../Forms/IntakeForm';
import { getResidueIntake } from '../../../../../slices/residueIntake/thunk';

const AddEditIntakeModal = ({
	dataResidueIntake,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	establishmentId,
}) => {
	const dispatch = useDispatch();

	// Si estamos editando, refrescamos el detalle para conocer la flag `has_consumption`
	// (D-011). Si el backend aún no la devuelve, el PUT terminará con 409 y el thunk
	// mostrará el toast correspondiente.
	useEffect(() => {
		if (isOpen && isEdit && dataResidueIntake?._id) {
			dispatch(getResidueIntake(dataResidueIntake._id));
		}
	}, [isOpen, isEdit, dataResidueIntake?._id, dispatch]);

	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Registrar'} Ingreso RESPEL
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '1' })}
							onClick={() => toggleTab('1')}
						>
							Información del Ingreso
						</NavLink>
					</NavItem>
				</Nav>
			</div>

			<IntakeForm
				dataResidueIntake={dataResidueIntake}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				establishmentId={establishmentId}
			/>
		</Modal>
	);
};

export default AddEditIntakeModal;
